import { useState, useCallback } from 'react'


export default function useModalState(def: boolean = false) {
  const [modalOpened, setModalOpened] = useState(def)

  const openModal = useCallback(() => {
    setModalOpened(true)
  }, [])

  const closeModal = useCallback(() => {
    setModalOpened(false)
  }, [])

  return [modalOpened, openModal, closeModal] as const
}
